/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="app.common.filters.module.ts" />
/// <reference path="../services/globalsettingsservice.ts" />

module App.Common.Filters {
	'use strict';

	export class HcaDateTimeFilter {

		public static $inject = ['$filter', 'app.common.services.globalSettingsService'];
		constructor($filter: ng.IFilterService, globalSettings: Common.Services.GlobalSettingsService) {
			return (input: Date): string => {
				var angularDateFilter = $filter('date');
				if (input) {
					return angularDateFilter(input, globalSettings.shortDateTimeFormat);
				} else {
					return '';
				}
			};
		}

	}

	angular
		.module('app.common.filters')
		.filter('hcaDate', HcaDateFilter);
}